import React, {Component} from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import Paper from '@material-ui/core/Paper';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';
import classes from './GeneralTableComponent.module.scss';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TablePaginationActionsWrapped from '../GeneralPaginationComponent/TablePaginationActions';

import {
    IButtonCell,
    IImageCell,
    IOrderButtonsCell,
    ITextCell,
    IToggleButtonCell,
    TableCellTypes,
    IRenderedCell,
} from '../TableCellTypes/TableCellTypes';
import {observer} from 'mobx-react';
import Spinner from '../../Spinner';

interface IProps {
    title?: string;
    emptyMessage: string;
    tableData: any[];
    tableHeader: { title: string }[];
    tableCellTypes: TableCellTypes[];
    addButton?: {
        title: string;
        onAdd(): void;
    };
    loading?: boolean;
}

@observer
class GeneralTableComponent extends Component<IProps> {

    state = {
        checkedA: true,
        checkedB: true,
        title: ''
    };

    handleChange = (name: any) => (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        this.setState({[name]: event.target.checked});
    };

    getTextCell = (rowIndex: number, value: string, cell: ITextCell, cellIndex: number) => {
        return (
            <TableCell className={classes.textCell} key={cellIndex}>{value}</TableCell>
        );
    };

    getToggleButtonCell = (rowIndex: number, value: boolean, cell: IToggleButtonCell, cellIndex: number) => {
        return (
            <TableCell key={cellIndex}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={value}
                            onChange={(event: any) => cell.onChange(rowIndex, cell.key, event.target.checked)}
                            color='primary'
                        />
                    }
                    label={value ? cell.activeLabel : cell.inactiveLabel}
                />
            </TableCell>
        );
    };

    getButtonCell = (rowIndex: number, value: string, cell: IButtonCell, cellIndex: number) => {
        return (
            <TableCell key={cellIndex}>
                <Button variant='contained'
                        color='primary'
                        className={classes.btnCell}
                        onClick={() => cell.onClick(rowIndex, cell.key)}
                        type='button'
                        disabled={cell.disabled !== null && cell.disabled !== undefined ? cell.disabled(rowIndex) : false}
                >
                    {value}
                </Button>
            </TableCell>
        );
    };

    getImageCell = (rowIndex: number, value: string, cell: IImageCell, cellIndex: number) => {
        return (
            <TableCell key={cellIndex}>
                <img src={value} className={classes.image}/>
            </TableCell>
        );
    };
    getImagesCell = (rowIndex: number, value: string[]) => {
        return (<TableCell>
            {value && value.map(img => {
                return <img src={img} style={{margin: '0 10px 0 0'}} key={img} className={classes.image}/>;
            })}
        </TableCell>)
    };

    getOrderButtonsCell = (rowIndex: number, cell: IOrderButtonsCell, cellIndex: number, tableLength: number) => {
        return (
            <TableCell key={cellIndex}>
                <Button variant='contained'
                        className={classes.upButton}
                        disabled={rowIndex === 0}
                        color='primary'
                        onClick={() => cell.onUpButtonClick(rowIndex, cell.key)}
                        type='button'>
                    {cell.upButtonText}
                </Button>
                <Button variant='contained'
                        disabled={rowIndex + 1 === tableLength}
                        color='primary'
                        onClick={() => cell.onDownButtonClick(rowIndex, cell.key)}
                        type='button'>
                    {cell.downButtonText}
                </Button>
            </TableCell>
        );
    };

    getRenderedCell = (cell: IRenderedCell, value: any, cellIndex: number) => {
        return (
            <TableCell key={cellIndex}>
                {cell.render(value)}
            </TableCell>
        );
    };

    getRowElements = (row: any, rowIndex: number, tableLength: number): any => {
        const elements: any[] = [];
        for (let i = 0; i < this.props.tableCellTypes.length; i++) {
            if (this.props.tableCellTypes[i].cellType === 'ToggleButton') {
                elements.push(
                    this.getToggleButtonCell(row.id, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as IToggleButtonCell, i),
                );
            } else if (this.props.tableCellTypes[i].cellType === 'Text') {
                elements.push(
                    this.getTextCell(row.id, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as ITextCell, i),
                );
            } else if (this.props.tableCellTypes[i].cellType === 'Button') {
                elements.push(
                    this.getButtonCell(row.id, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as IButtonCell, i),
                );
            } else if (this.props.tableCellTypes[i].cellType === 'Image') {
                elements.push(
                    this.getImageCell(row.id, row[this.props.tableCellTypes[i].key], this.props.tableCellTypes[i] as IImageCell, i),
                );
            } else if (this.props.tableCellTypes[i].cellType === 'Images') {
                elements.push(
                    this.getImagesCell(row.id, row[this.props.tableCellTypes[i].key]),
                );
            } else if (this.props.tableCellTypes[i].cellType === 'OrderButtons') {
                elements.push(
                    this.getOrderButtonsCell(row.id, this.props.tableCellTypes[i] as IOrderButtonsCell, i, tableLength),
                );
            } else if (this.props.tableCellTypes[i].cellType === 'render') {
                elements.push(
                    this.getRenderedCell(this.props.tableCellTypes[i] as IRenderedCell, row, i),
                );
            }
        }
        return elements;
    };
    handleChangePage = (event: any, page: number) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = (event: any) => {
        this.setState({page: 0, rowsPerPage: Number(event.target.value)});
    };

    render() {
        let addButton = null;
        if (this.props.addButton) {
            addButton = (
                <Button variant='contained'
                        color='primary'
                        className={classes.addButton}
                        onClick={() => this.props.addButton!.onAdd()}
                        type='button'>
                    {this.props.addButton!.title}
                </Button>
            );
        }

        const tableDataLength = this.props.tableData.length;

        return (
            (this.props.tableData.length === 0) ? (
                <div className={classes.emptyContainer}>
                    <div className={classes.card}>
                        <Typography variant='subtitle1' gutterBottom className={classNames(classes.content)}>
                            {this.props.emptyMessage}
                        </Typography>
                        <div className={classes.actions}>
                            {addButton}
                        </div>
                    </div>
                </div>
            ) : ((this.props.loading) ?
                <Spinner/>
                : (
                    <div className={classes.tableContainer}>
                        <Typography variant='title' gutterBottom className={classNames(classes.content)}>
                            {this.props.title ? this.props.title : 'Student'}
                        </Typography>

                        <div className={classes.actions}>
                            {addButton}
                        </div>
                        <Paper className={classes.root}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHead}>
                                        {
                                            this.props.tableHeader.map((ele, index) => (
                                                <TableCell key={index} className={classes.cell}>{ele.title}</TableCell>
                                            ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.props.tableData
                                            .map((row, rowIndex) => (
                                                <TableRow key={rowIndex}>
                                                    {
                                                        this.getRowElements(row, rowIndex, tableDataLength)
                                                    }
                                                </TableRow>
                                            ))
                                    }
                                </TableBody>
                            </Table>
                        </Paper>
                    </div>
                ))
        );
    }
}

export default GeneralTableComponent;
